import $axios from '@/utils/request'

// 上传图片
export function getChildTa (data) {
  const url = '/dingtalk/getChildTa'
  return $axios.fGet(url, data)
}
